<div class="success__page">
    <div class="row text-center my-4">
        <div class="col-md-12">
            <div class="auth-section--logo">
                <img [src]="commonService?.getOrgWindowObject?.LOGO_URL ? commonService?.getOrgWindowObject?.LOGO_URL : 'assets/images/logo.png'" 
                onerror="this.src='assets/images/logo.png';" alt="Logo">
            </div>
        </div>
    </div>
    <div class="row justify-content-md-center">
        <div class="col-md-5 text-center py-5 success__box">
            <h4 class="font-weight-bold">Successfull payment</h4>
            <small class="color--gray--2">Thank you! Now you can see the Final Value of Report</small>
            <br>
            <svg-icon name="orion-bill" svgClass="mb-5 mt-3"></svg-icon>
            <br>
            <button type="button" class="button primary__button px-5" *ngIf="reportId" (click)="gotoConclusion()">
                See the final value
            </button>
        </div>
        <div class="col-md-3 gray__box my-5">
            <small class="color--gray--2">Your choice & benefits</small>

            <div class="row color--green">
                <div class="col-md-12 my-2">
                    <em class="fa fa-check"></em>
                    Enter the company info, financials, risks
                </div>
                <div class="col-md-12 my-2">
                    <em class="fa fa-check"></em>
                    Detailed business valuation
                </div>
                <div class="col-md-12 my-2">
                    <em class="fa fa-check"></em>
                    All educational tips and information
                </div>
                <div class="col-md-12 my-2">
                    <em class="fa fa-check"></em>
                    Collaboration tools and reviews
                </div>
            </div>
        </div>
    </div>

    <div class="row justify-content-md-center">

    </div>

</div>